import api from './api'

export const couponsService = {
  list: async (params = {}) => {
    const response = await api.get('/api/settings/coupons', { params })
    return response.data
  },

  getById: async (id) => {
    const response = await api.get(`/api/settings/coupons/${id}`)
    return response.data
  },

  create: async (payload) => {
    const response = await api.post('/api/settings/coupons', payload)
    return response.data
  },

  update: async (id, payload) => {
    const response = await api.put(`/api/settings/coupons/${id}`, payload)
    return response.data
  },

  deactivate: async (id) => {
    const response = await api.delete(`/api/settings/coupons/${id}`)
    return response.data
  },
}
